import React from 'react';

function OutlineButton({title, onClick}) {
  return (
    <button id="OutlineButton" onClick={onClick}>
      {title}
    </button>
  );
}

export default OutlineButton;